import { render, staticRenderFns } from "./xcxgl.vue?vue&type=template&id=6f0518fd&scoped=true&"
import script from "./xcxgl.vue?vue&type=script&lang=js&"
export * from "./xcxgl.vue?vue&type=script&lang=js&"
import style0 from "./xcxgl.vue?vue&type=style&index=0&id=6f0518fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0518fd",
  null
  
)

export default component.exports